"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewsletterSubscriptionConfirmation = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classNames_1 = require("../../../../utils/classNames");
const theme_1 = require("../../../../utils/theme");
const MediaRenderer_1 = require("../../../atomic/templates/MediaRenderer");
// Define the component using destructuring
const NewsletterSubscriptionConfirmation = ({ data: { icon, title, helpingText } }) => {
    const theme = (0, theme_1.useTheme)();
    const titleClassName = (0, classNames_1.cn)(theme.components.subscriptionConfirmation.title);
    const helpingTextClassName = (0, classNames_1.cn)(theme.components.subscriptionConfirmation.helpingText);
    const iconClassName = (0, classNames_1.cn)(theme.components.subscriptionConfirmation.icon);
    // Render the component
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col items-center justify-center gap-4", children: [icon?.media && ((0, jsx_runtime_1.jsx)(MediaRenderer_1.MediaRenderer, { media: icon.media, component: (mediaProps) => ((0, jsx_runtime_1.jsx)("img", { src: mediaProps.src, alt: "info icons", className: iconClassName })) })), (0, jsx_runtime_1.jsx)("h5", { className: titleClassName, children: title }), (0, jsx_runtime_1.jsx)("p", { className: helpingTextClassName, children: helpingText })] }));
};
exports.NewsletterSubscriptionConfirmation = NewsletterSubscriptionConfirmation;
